module.exports = __webpack_public_path__ + "img/af2bb55.png";